"use strict";

var _classCallCheck = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _get = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _getPrototypeOf = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnchorsComponent = void 0;

var Point2D_1 = require("../../Core/Point2D");

var IRegionCallbacks_1 = require("../../Interface/IRegionCallbacks");

var RegionComponent_1 = require("./RegionComponent");
/**
 * An abstract visual component used internall to draw anchor points that allow
 * region points moving and this component resizing.
 */


var AnchorsComponent = /*#__PURE__*/function (_RegionComponent_1$Re) {
  _inherits(AnchorsComponent, _RegionComponent_1$Re);

  /**
   * Creates a new `AnchorsComponent` object.
   * @param paper - The `Snap.Paper` object to draw on.
   * @param paperRect - The parent bounding box for created component.
   * @param regionData - The `RegionData` object shared across components. Used also for initial setup.
   * @param callbacks - The external callbacks collection.
   */
  function AnchorsComponent(paper) {
    var _this;

    var paperRect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var regionData = arguments.length > 2 ? arguments[2] : undefined;
    var callbacks = arguments.length > 3 ? arguments[3] : undefined;

    _classCallCheck(this, AnchorsComponent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AnchorsComponent).call(this, paper, paperRect, regionData, callbacks));
    /**
     * The index of currently active anchor.
     * 0 - none
     * 1, 2, ... - one of point anchors
     * -1, -2, ... - one of bone anchors
     */

    _this.activeAnchorIndex = 0;
    /**
     * Dragging state of the component.
     */

    _this.isDragged = false;
    _this.node = _this.paper.g();

    _this.node.addClass("anchorsLayer");

    _this.anchors = [];
    _this.anchorsNode = _this.paper.g();

    _this.node.add(_this.anchorsNode);

    _this.buildAnchors();

    return _this;
  }
  /**
   * Redraws the visual on the component.
   */


  _createClass(AnchorsComponent, [{
    key: "redraw",
    value: function redraw() {
      var _this2 = this;

      if (this.regionData.points !== null && this.regionData.points.length > 0) {
        window.requestAnimationFrame(function () {
          _this2.regionData.points.forEach(function (p, index) {
            // Workaround - sometimes there is NPE when we resize the box
            if (index < _this2.anchors.length) {
              _this2.anchors[index].attr({
                cx: p.x,
                cy: p.y
              });
            }
          });
        });
      }
    }
    /**
     * Switches the component to the frozen state.
     */

  }, {
    key: "freeze",
    value: function freeze() {
      _get(_getPrototypeOf(AnchorsComponent.prototype), "freeze", this).call(this);
    }
    /**
     * Creates a collection on anchors.
     */

  }, {
    key: "buildAnchors",
    value: function buildAnchors() {
      var _this3 = this;

      this.buildPointAnchors();
      this.buildGhostAnchor();
      this.subscribeToEvents([{
        event: "pointerleave",
        base: this.node.node,
        listener: function listener(e) {
          if (!_this3.isDragged) {
            window.requestAnimationFrame(function () {
              _this3.ghostAnchor.attr({
                display: "none"
              });
            });
          }
        },
        bypass: true
      }]);
    }
    /**
     * Creates a collection of anchor points.
     */

  }, {
    key: "buildPointAnchors",
    value: function buildPointAnchors() {
      var _this4 = this;

      this.regionData.points.forEach(function (point, index) {
        var anchor = _this4.createAnchor(_this4.paper, point.x, point.y);

        _this4.anchors.push(anchor);

        _this4.anchorsNode.add(anchor);

        _this4.subscribeAnchorToEvents(anchor, index + 1);
      });
    }
    /**
     * Creates the ghost anchor.
     */

  }, {
    key: "buildGhostAnchor",
    value: function buildGhostAnchor() {
      this.ghostAnchor = this.createAnchor(this.paper, 0, 0, "ghost", AnchorsComponent.DEFAULT_GHOST_ANCHOR_RADIUS);
      this.ghostAnchor.attr({
        display: "none"
      });
      this.node.add(this.ghostAnchor);
      this.subscribeGhostToEvents();
    }
    /**
     * Helper function to subscribe anchor to activation event.
     * @param anchor - The anchor for wire up.
     * @param index - The index of the anchor used to define which one is active.
     */

  }, {
    key: "subscribeAnchorToEvents",
    value: function subscribeAnchorToEvents(anchor, index) {
      var _this5 = this;

      this.subscribeToEvents([{
        event: "pointerenter",
        base: anchor.node,
        listener: function listener(e) {
          // Set drag origin point to current anchor
          _this5.activeAnchorIndex = index;

          var anchorPoint = _this5.getActiveAnchorPoint(e); // Move ghost anchor to current anchor position


          window.requestAnimationFrame(function () {
            _this5.ghostAnchor.attr({
              cx: anchorPoint.x,
              cy: anchorPoint.y,
              display: "block"
            });
          });
        },
        bypass: false
      }]);
    }
    /**
     * Helper function to create a new anchor.
     * @param paper - The `Snap.Paper` object to draw on.
     * @param x - The `x`-coordinate of the acnhor.
     * @param y - The `y`-coordinate of the anchor.
     * @param style - Additional css style class to be applied.
     * @param r - The radius of the anchor.
     */

  }, {
    key: "createAnchor",
    value: function createAnchor(paper, x, y, style) {
      var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : AnchorsComponent.DEFAULT_ANCHOR_RADIUS;
      var a = paper.circle(x, y, r);
      a.addClass("anchorStyle");

      if (style !== undefined && style !== "") {
        a.addClass(style);
      }

      return a;
    }
    /**
     * Callback for the pointerenter event for the ghost anchor.
     * @param e - PointerEvent object.
     */

  }, {
    key: "onGhostPointerEnter",
    value: function onGhostPointerEnter(e) {// do nothing
    }
    /**
     * Callback for the pointerleave event for the ghost anchor.
     * @param e - PointerEvent object.
     */

  }, {
    key: "onGhostPointerLeave",
    value: function onGhostPointerLeave(e) {
      var _this6 = this;

      if (!this.isDragged) {
        window.requestAnimationFrame(function () {
          _this6.ghostAnchor.attr({
            display: "none"
          });
        });
        this.activeAnchorIndex = 0;
      }
    }
    /**
     * Callback for the pointerdown event for the ghost anchor.
     * @param e - PointerEvent object.
     */

  }, {
    key: "onGhostPointerDown",
    value: function onGhostPointerDown(e) {
      this.ghostAnchor.node.setPointerCapture(e.pointerId);
      var offsetX = e.clientX - e.target.closest("svg").getBoundingClientRect().left;
      var offsetY = e.clientY - e.target.closest("svg").getBoundingClientRect().top;
      this.dragOrigin = new Point2D_1.Point2D(offsetX, offsetY);
      this.isDragged = true;
      this.callbacks.onManipulationLockRequest(this);
      this.callbacks.onChange(this, this.regionData.copy(), IRegionCallbacks_1.ChangeEventType.MOVEBEGIN);
    }
    /**
     * Callback for the pointermove event for the ghost anchor.
     * @param e - PointerEvent object.
     */

  }, {
    key: "onGhostPointerMove",
    value: function onGhostPointerMove(e) {
      var _this7 = this;

      if (this.isDragged) {
        var ghost = e.target.getBoundingClientRect();
        var rdx = e.clientX - ghost.left;
        var rdy = e.clientY - ghost.top;
        var offsetX = e.clientX - e.target.closest("svg").getBoundingClientRect().left;
        var offsetY = e.clientY - e.target.closest("svg").getBoundingClientRect().top;
        var dx = offsetX - this.dragOrigin.x;
        var dy = offsetY - this.dragOrigin.y;

        if (rdx < 0 && dx > 0 || rdx > 0 && dx < 0) {
          dx = 0;
        }

        if (rdy < 0 && dy > 0 || rdy > 0 && dy < 0) {
          dy = 0;
        }

        if (this.activeAnchorIndex !== 0) {
          var anchorPoint = this.getActiveAnchorPoint(e);
          var p = new Point2D_1.Point2D(anchorPoint.x + dx, anchorPoint.y + dy);

          if (this.paperRect !== null) {
            p = p.boundToRect(this.paperRect);
          }

          window.requestAnimationFrame(function () {
            _this7.ghostAnchor.attr({
              cx: p.x,
              cy: p.y
            });
          });
          this.updateRegion(p);
        }

        this.dragOrigin = new Point2D_1.Point2D(offsetX, offsetY);
      }
    }
    /**
     * Callback for the pointerup event for the ghost anchor.
     * @param e - PointerEvent object.
     */

  }, {
    key: "onGhostPointerUp",
    value: function onGhostPointerUp(e) {
      var _this8 = this;

      this.ghostAnchor.node.releasePointerCapture(e.pointerId);
      this.callbacks.onManipulationLockRelease(this);
      this.callbacks.onChange(this, this.regionData.copy(), IRegionCallbacks_1.ChangeEventType.MOVEEND);
      this.activeAnchorIndex = 0;
      this.dragOrigin = null;
      this.isDragged = false;
      window.requestAnimationFrame(function () {
        _this8.ghostAnchor.attr({
          display: "none"
        });
      });
    }
    /**
     * Subscribe event listeners on the ghost anchor
     */

  }, {
    key: "subscribeGhostToEvents",
    value: function subscribeGhostToEvents() {
      var listeners = [{
        event: "pointerenter",
        base: this.ghostAnchor.node,
        listener: this.onGhostPointerEnter,
        bypass: false
      }, {
        event: "pointerleave",
        base: this.ghostAnchor.node,
        listener: this.onGhostPointerLeave,
        bypass: false
      }, {
        event: "pointerdown",
        base: this.ghostAnchor.node,
        listener: this.onGhostPointerDown,
        bypass: false
      }, {
        event: "pointerup",
        base: this.ghostAnchor.node,
        listener: this.onGhostPointerUp,
        bypass: false
      }, {
        event: "pointermove",
        base: this.ghostAnchor.node,
        listener: this.onGhostPointerMove,
        bypass: false
      }];
      this.subscribeToEvents(listeners);
    }
    /**
     * Returns `Point2D` with coordinates of active anchor
     */

  }, {
    key: "getActiveAnchorPoint",
    value: function getActiveAnchorPoint(e) {
      if (this.activeAnchorIndex > 0) {
        return this.regionData.points[this.activeAnchorIndex - 1];
      } else {
        return null;
      }
    }
  }]);

  return AnchorsComponent;
}(RegionComponent_1.RegionComponent);

exports.AnchorsComponent = AnchorsComponent;
/**
 * Default radius for anchor poitns. Can be redefined through CSS styles.
 */

AnchorsComponent.DEFAULT_ANCHOR_RADIUS = 3;
/**
 * Defailt radius for the ghost anchor, used activate dragging. Can be redefined through CSS styles.
 */

AnchorsComponent.DEFAULT_GHOST_ANCHOR_RADIUS = 7;